interface ProductParams { product: string; category: string }

class GoogleAnalyticsService {
  static instance: GoogleAnalyticsService;
  static use() {
    if (!GoogleAnalyticsService.instance) GoogleAnalyticsService.instance = new GoogleAnalyticsService();
    return GoogleAnalyticsService.instance;
  }

  private objectToStringFix(object: Record<string, unknown>) {
    if (!object) return null;
    const copy: any = structuredClone(object);
    for (const [key, value] of Object.entries(copy)) {
      if (typeof value === 'object' && value !== null) {
        copy[key].toString = function () {
          return JSON.stringify(this);
        };
      }
    }
    return copy;
  }

  private productParams: ProductParams | null = null;

  setProductParams(productParams: ProductParams): void {
    this.productParams = productParams;
  }

  send(event: string, payload: Record<string, unknown> = {}) {
    if (typeof window.gtag !== 'function') {
      console.warn(`[QIC-Analytics] Event ${event} wasn't sent by GoogleAnalyticsService`);
      return;
    }

    const resultPayload = Object.assign({}, this.productParams, payload, { migration_flow: 'new' });
    const patchedPayload = this.objectToStringFix(resultPayload);
    const args: ['event', string, any?] = ['event', event];
    if (patchedPayload) {
      args.push(patchedPayload);
    }

    window.gtag(...args);

    console.info(`[QIC-Analytics] Event ${event} is sent by GoogleAnalyticsService`);
  }
}

export const useGoogleAnalytics = () => GoogleAnalyticsService.use();
